import { setLocal, getLocal } from '@/common/js/api'

export default {
  data() {
    return {
      loading: null,
      pageIndex: 1,
      pageSize: parseInt(getLocal('PAGESIZE')) || 20,
      total: 0,
      modalColumn: false, // 自定义列
      sort: '',
      order: ''
    }
  },
  methods: {
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageIndex = 1
      this.pageSize = size
      this.getData()
    },
    setLocalPage(size) {
      setLocal('PAGESIZE', size)
    },
    filterData(params) {
      this.pageIndex = 1
      this.getData(params)
    },
    sortTable({ prop, order }) {
      const orderType = {
        ascending: 'asc',
        descending: 'desc'
      }
      this.order = orderType[order]
      this.sort = prop
      this.pageIndex = 1
      this.getData()
    }
  }
}
